import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noDeployments: {
		id: 'software-releases-launch-card.latest-deployment.no-deployments',
		defaultMessage: 'No deployments for the last week',
		description: 'Message displayed when there were no deployments for a version in the last week',
	},
	lastDeployment: {
		id: 'software-releases-launch-card.latest-deployment.last-deployment',
		defaultMessage: 'Last deployment: ',
		description: 'Text label for the last deployment timestamp',
	},
	loading: {
		id: 'software-releases-launch-card.latest-deployment.loading',
		defaultMessage: 'Loading...',
		description: 'Label for when data is being loaded',
	},
});
